export default "__VITE_ASSET__7W6or8EH__"